module.exports = __webpack_public_path__ + "img/avbi03d.93882f53.png";